import { render, staticRenderFns } from "./workflow-transition-table-item.vue?vue&type=template&id=c8d7c7d2"
import script from "./workflow-transition-table-item.vue?vue&type=script&lang=js"
export * from "./workflow-transition-table-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports